import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['firstName', 'lastName', 'emailInput'];

  fillNames(event) {
    const { firstName, lastName, email } = event.detail.selection.dataset;
    
    if (this.hasFirstNameTarget && firstName) {
      this.firstNameTarget.value = firstName;
    }
    
    if (this.hasLastNameTarget && lastName) {
      this.lastNameTarget.value = lastName;
    }

    if (this.hasEmailInputTarget && email) {
      this.emailInputTarget.value = email;
    }
  }

  // Clear fields if the email is changed manually after selection
  clearIfChanged(event) {
    // Optional: add logic to clear user_id hidden field if email is changed
  }
}
